import React, { useState, useEffect } from 'react'
import Step1 from '@UI/crypto_exchange/desktop/pages/account/components/ProfileInfo/components/DocumentRequest/components/ProblemGambler/Step1/Step1'
import Step2 from '@UI/crypto_exchange/desktop/pages/account/components/ProfileInfo/components/DocumentRequest/components/ProblemGambler/Step2/Step2'
import Step3 from '@UI/crypto_exchange/desktop/pages/account/components/ProfileInfo/components/DocumentRequest/components/ProblemGambler/Step3/Step3'
import StepSuccess from '@UI/crypto_exchange/desktop/pages/account/components/ProfileInfo/components/DocumentRequest/components/ProblemGambler/StepSuccess/StepSuccess'
import StepExclude from '@UI/crypto_exchange/desktop/pages/account/components/ProfileInfo/components/DocumentRequest/components/ProblemGambler/StepExclude/StepExclude'
import ModalWrapper from '@UI/crypto_exchange/mobi/components/modals/ModalWrapper'

import cls from './ProblemGamblerModal.module.scss'
import { CloseIcon } from '@Static/icons/ArrowIcons'
import { useAppSelector } from '@App/hooks'
import { Close } from '@Static/icons/ToastIcons'

interface Props {
  isOpen: boolean
  setIsOpen: () => void
  doc?: any
  time_loc?: number | string | null
  initial_step?: number
}

const ProblemGamblerModal: React.FC<Props> = ({ initial_step = 1, setIsOpen, time_loc, isOpen, doc }) => {
  const [step, setStep] = useState<number>(initial_step || 1)
  const [params, setParams] = useState<any>(null)
  const isLogin = useAppSelector(state => state.user.login)

  useEffect(() => {
    if (!isLogin) setIsOpen()
  }, [isLogin])

  useEffect(() => {
    if (isOpen && doc) {
      setStep(doc.step === 'error_timeout' ? 3 : initial_step)
    }
  }, [isOpen, doc, initial_step])

  const closeModal = () => {
    setIsOpen()
  }

  const changeStep = (newStep: number, stepParams: any = null) => {
    setStep(newStep)
    if (stepParams) {
      setParams(stepParams)
    }
  }

  const getStepClass = (currentStep: number): string => {
    switch (currentStep) {
      case 3:
        return cls.stepRealityCheck
      case 4:
        return cls.stepSuccess
      case 6:
        return cls.stepExclude
      default:
        return ''
    }
  }

  const renderStep = () => {
    if (!doc) return null

    switch (step) {
      case 1:
        return <Step1 changeStep={changeStep} timeLoc={time_loc} doc={doc} />
      case 2:
        return <Step2 doc={doc} changeStep={changeStep} closeModal={closeModal} />
      case 3:
        return <Step3 changeStep={changeStep} closeModal={closeModal} />
      case 4:
        return <StepSuccess closeModal={closeModal} />
      case 6:
        return <StepExclude params={params} changeStep={changeStep} closeModal={closeModal} />
      default:
        return <Step1 changeStep={changeStep} timeLoc={time_loc} doc={doc} />
    }
  }

  return (
    <ModalWrapper isOpen={isOpen} setIsOpen={setIsOpen} withOutsideClick={false}>
      <div className={`${cls.container} ${getStepClass(step)}`}>
        <div className={cls.form}>
          <Close onClick={() => closeModal()} className={cls.closeIcon} />
          {renderStep()}
        </div>
      </div>
    </ModalWrapper>
  )
}

export default ProblemGamblerModal
